import React, { useContext, useState } from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import UploadArea, {
  UploadedReadedFile,
} from 'shared/lib/components/controls/uploadArea/uploadArea';
import { UiContext } from 'shared/lib/contexts/uiContext';
import IconInfo from 'shared/icons/iconInfo';
import DesktopSmallModal from 'shared/lib/components/modals/desktopSmallModal';
import { borderRadiusValues } from 'shared/lib/utils/uiConstants';
import 'cropperjs/dist/cropper.css';
import CroppModal from 'shared/lib/components/modals/croppModal';
import { useTranslation } from 'react-i18next';
import IconFolder from 'shared/icons/iconFolder';

export type UploadPreviewTextProps = {
  preview?: UploadedReadedFile;
  onSetPreview: (preview: UploadedReadedFile) => void;
};

export default function UploadPreviewText({
  preview,
  onSetPreview,
}: UploadPreviewTextProps) {
  const {
    spacings: { icons },
  } = useContext(UiContext);
  const theme = useTheme();
  const { t } = useTranslation();

  const [isModalOpen, setisModalOpen] = useState(false);
  const [isCropp, setIsCropp] = useState(false);

  return (
    <>
      {preview ? (
        <>
          <Box
            onClick={() => setisModalOpen(true)}
            sx={{
              'width': icons['40x22'].w,
              'height': icons['40x22'].h,
              'display': 'flex',
              'justifyContent': 'center',
              'alignItems': 'center',
              'bgcolor': 'custom.previewImageBg',
              'borderColor': 'text.secondary',
              'borderRadius': borderRadiusValues.XSmall,
              'cursor': 'pointer',
              '& .preview-image': {
                borderRadius: 'inherit',
                objectFit: 'contain',
                maxWidth: '100%',
                maxHeight: '100%',
              },
            }}
          >
            <img
              className="preview-image"
              src={preview.dataUrl}
              alt="preview"
            ></img>
          </Box>
          <Typography
            sx={{ cursor: 'pointer' }}
            color="text.secondary"
            variant="f14"
            onClick={() => setisModalOpen(true)}
          >
            {preview.originalFile.name}
          </Typography>
        </>
      ) : (
        <>
          <IconInfo extColor={theme.palette.error.main}></IconInfo>
          <Box>
            <Typography
              color="text.secondary"
              sx={{
                borderBottom: 1,
                height: 0.9,
                borderColor: 'text.secondary',
                cursor: 'pointer',
              }}
              variant="f14"
              onClick={() => setisModalOpen(true)}
            >
              Добавьте миниатюру
            </Typography>
            &nbsp;
            <Typography color="text.secondary" variant="f14">
              в формате JPG или PNG
            </Typography>
          </Box>
        </>
      )}

      <DesktopSmallModal
        isOpen={isModalOpen}
        handleClose={() => setisModalOpen(false)}
        disableCloseIcon={true}
      >
        <UploadArea
          isDataUrl
          accept={{
            'image/jpeg': ['.jpeg'],
            'image/jpg': ['.jpg'],
            'image/png': ['.png'],
          }}
          areMultipleUploadsAllowed={true}
          innerSx={{ height: 550 }}
          text={t('noCategory.uploadFileHelp')}
          buttonText={t('actions.filesUpload')}
          icon={
            <IconFolder
              sizeKey="48x48"
              extColor={theme.palette.text.secondary}
            />
          }
          handleAddFile={(image) => {
            onSetPreview(image);
            setisModalOpen(false);
            setIsCropp(true);
          }}
        ></UploadArea>
      </DesktopSmallModal>

      {isCropp && preview ? (
        <CroppModal
          isOpen={true}
          handleClose={() => setIsCropp(false)}
          src={preview.dataUrl}
          type={preview.originalFile.type}
          name={preview.originalFile.name}
          onApply={(uploadedFile) => {
            onSetPreview(uploadedFile);
          }}
        ></CroppModal>
      ) : (
        ''
      )}
    </>
  );
}
